import type { ChangelogAdvancedPayload } from "./changelog-advanced.model";

/** Structured changelog for Snoots PMS v1.43.75 (advanced template). */
export const CHANGELOG_ADVANCED_PAYLOAD_V143_75: ChangelogAdvancedPayload = {
  omitTabNavigation: true,
  titleKey: "changelog.advanced.title",
  subtitleKey: "changelog.advanced.subtitle.v14375",
  brandKey: "changelog.advanced.brand.pms",
  helpCenterLabelKey: "changelog.advanced.helpCenter",
  helpCenterUrl: "https://helpcenter.snoots.pet/",
  footnoteKey: "changelog.advanced.footer.v14375",
  stats: [
    {
      value: 4,
      labelKey: "changelog.advanced.stat.newFeatures",
      accentColor: "#0F6E56"
    }
  ],
  tabs: [
    {
      id: "video",
      labelKey: "changelog.advanced.tab.video",
      count: 4,
      accentColor: "#185FA5",
      kind: "video",
      youtubeVideoId: "WyLAEOtveGA",
      videoHeadingKey: "changelog.advanced.v14375.video.heading",
      videoCaptionKey: "changelog.advanced.v14375.video.caption",
      youtubeOpenLabelKey: "changelog.advanced.v14375.video.openYoutube",
      bulletsAfterVideoLabelKey:
        "changelog.advanced.v14375.video.detailsHeading",
      items: [
        {
          textKey: "changelog.advanced.v14375.item.1"
        },
        {
          textKey: "changelog.advanced.v14375.item.2"
        },
        {
          textKey: "changelog.advanced.v14375.item.3"
        },
        {
          textKey: "changelog.advanced.v14375.item.4"
        }
      ]
    }
  ]
};
